import React from 'react';
import PropTypes from 'prop-types';
import PublishSubmitMenuModal from './PublishSubmitMenuModal';
import ActivityTypes from '../../../../../enums/activityTypes';

const PublishMenuModal = ({ modalData, setModalData, fromMoreActions, activityType }) => {
  return (
    <PublishSubmitMenuModal
      title={`Publish ${activityType == ActivityTypes.FlashCard ? 'flashcard' : 'assignment'} as a Public ${activityType == ActivityTypes.FlashCard ? 'Flashcard' : 'Assignment'}`}
      isOpen={modalData}
      onClose={setModalData}
      textboxLabel={`Name for the Public ${activityType == ActivityTypes.FlashCard ? 'Flashcard' : 'Assignment'}`}
      apiParamOptions={0}
      confirmationMsg={
        `Are you sure that you want to make this ${activityType == ActivityTypes.FlashCard ? 'flashcard' : 'assignment'} public for all teachers in your district to use?`
      }
      fromMoreActions={fromMoreActions}
      helpText={`To publish your ${activityType == ActivityTypes.FlashCard ? 'flashcard' : 'assignment'} as a Public ${activityType == ActivityTypes.FlashCard ? 'Flashcard' : 'Assignment'}, accessible to all teachers in your school district, please specify a name for the Public Set, then click the Publish button.`}
      activityType={activityType}
    />
  );
};

PublishMenuModal.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func,
  fromMoreActions: PropTypes.bool,
  activityType: PropTypes.number
};

export default PublishMenuModal;
